const releases = [
  {
    version: "1.0.0",
    date: "2026-04-22",
    summary: "First official stable release — production-ready PWA.",
    added: [
      "Create, run, edit, and delete card-game sessions",
      "Persistent active session across page reloads",
      "Abort a live session with confirmation",
      "Score sheet image upload with pinch-to-zoom",
      "Session import from typed text",
      "AI import from photographed handwritten score sheets (Mistral Pixtral)",
      "Shareable read-only public link for any active session",
      "Live standings, settlements, and Who Pays Who in public view",
      "Auto-calculated Who Pays Who settlement",
      "WhatsApp share with full player results summary",
      "Per-session shared expense tracking with auto-split",
      "Player profiles, avatars, head-to-head stats, radar chart",
      "Net profit/loss charts, total buy-in stats, global podium, CSV export",
      "Three UI themes: Classic, Modern, Neon — switchable at runtime",
      "Light / Dark / System colour-scheme toggle",
      "Sentry error monitoring, Vercel Analytics & Speed Insights",
    ],
    fixed: [
      "Password reset redirect flow and upload button on mobile",
      "SessionSummaryModal and VarianceModal scrollable on small screens",
      "Total Pot and Total Won terminology standardised",
      "Numeric inputs use correct mobile keyboard type",
    ],
  },
];

export default function ChangelogPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-2xl mx-auto px-4 py-10 space-y-10">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">What's New</h1>
          <p className="text-muted-foreground mt-1 text-sm">SSC Score Tracker release history</p>
        </div>

        {releases.map((r) => (
          <div key={r.version} className="space-y-4">
            <div className="flex items-baseline gap-3">
              <span className="text-xl font-semibold">v{r.version}</span>
              <span className="text-xs text-muted-foreground">{r.date}</span>
            </div>
            <p className="text-sm text-muted-foreground">{r.summary}</p>

            {r.added.length > 0 && (
              <div className="space-y-1">
                <p className="text-xs font-semibold uppercase tracking-wider text-emerald-500">Added</p>
                <ul className="space-y-1">
                  {r.added.map((item) => (
                    <li key={item} className="flex gap-2 text-sm">
                      <span className="text-emerald-500 mt-0.5">+</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {r.fixed.length > 0 && (
              <div className="space-y-1">
                <p className="text-xs font-semibold uppercase tracking-wider text-blue-500">Fixed</p>
                <ul className="space-y-1">
                  {r.fixed.map((item) => (
                    <li key={item} className="flex gap-2 text-sm">
                      <span className="text-blue-500 mt-0.5">·</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <hr className="border-border" />
          </div>
        ))}

        <p className="text-xs text-muted-foreground text-center pb-4">
          SSC Score · Built with ♥ for the group
        </p>
      </div>
    </div>
  );
}
